import { toast } from "react-toastify";
import { prependNotification, setNewNotificationCount } from "../core/data/redux/notification/notificationSlice";
import store from "../core/data/redux/store";

const WS_BASE_URL = `wss://api.tracnest.com/ws/notifications`;


let socket: WebSocket | null = null;
let reconnectAttempts = 0;
const MAX_RECONNECT = 5;
let isAuthError = false;

const connect = () => {
    const token = localStorage.getItem("token");
    if (!token) {
        console.warn("No token found. Skipping WebSocket connection.");
        return;
    }

    const url = `${WS_BASE_URL}?token=${token}`;
    socket = new WebSocket(url);
    console.log('socket >>>>>>>>>>>. ', socket);

    socket.onopen = () => {
        console.log("WebSocket connected");
        reconnectAttempts = 0;
        isAuthError = false;
    };

    socket.onmessage = (event) => {
        try {
            const data = JSON.parse(event.data);
            console.log('data ==== ', data);

            console.log('latest_message +++++ ', data?.latest_message);
            if (data?.latest_message) {
                store.dispatch(setNewNotificationCount());
                toast.success(data?.latest_message);
                store.dispatch(prependNotification(data));
            }
        }
        catch (err) {
            console.error("Invalid WS message", err);
        }
    };

    socket.onclose = () => {
        if (reconnectAttempts < MAX_RECONNECT) {
            const delay = 1000 * (reconnectAttempts + 1);
            setTimeout(connect, delay);
            reconnectAttempts++;
        }
    };

    socket.onerror = (err) => console.error("WS error", err);
};

export const startNotificationSocket = () => {
    console.log('socket ========== ', socket);

    // Prevent double-connect
    if (socket?.readyState === WebSocket.OPEN || socket?.readyState === WebSocket.CONNECTING) return;
    connect();
};

export const stopNotificationSocket = () => {
    socket?.close();
    socket = null;
};